import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";

const BlogsAdmin = () => {
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [showFaqs, setShowFaqs] = useState(false);

  // Toolbar modules with full MS Word-like features
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headings
      [{ font: [] }], // Font selection
      [{ size: ["small", false, "large", "huge"] }], // Text sizes like MS Word
      [{ color: [] }, { background: [] }], // Text & background color
      ["bold", "italic", "underline", "strike"], // Formatting options
      [{ script: "sub" }, { script: "super" }], // Subscript / Superscript
      [{ align: [] }], // Text alignment (left, center, right, justify)
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      [{ indent: "-1" }, { indent: "+1" }], // Indentation
      ["blockquote", "code-block"], // Blockquote & Code block
      ["link", "image", "video"], // Insert links, images, and videos
      ["clean"], // Clear formatting
      ["undo", "redo"], // Undo & redo
    ],
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("faqs", JSON.stringify(faqs));
    try {
      await axios.post("http://localhost:5000/post/blogs", formData);

      alert("Blog saved successfully!");
      setTitle("");
      setContent("");
      setFaqs([]);
      fetchBlogs(); // Refresh blogs list
    } catch (error) {
      alert("Failed to save blog.");
    }
  };

  const fetchBlogs = async () => {
    try {
      const response = await axios.get("http://localhost:5000/get/blogs");
      setBlogs(response.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleAddFaq = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  const handleFaqChange = (index, field, value) => {
    const updatedFaqs = [...faqs];
    updatedFaqs[index][field] = value;
    setFaqs(updatedFaqs);
  };

  return (
    <div className="text-editor">
      <h2>Blogs Admin</h2>
      <input
        type="text"
        placeholder="Enter blog title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
      />

      <ReactQuill value={content} onChange={setContent} modules={modules} />

      <div style={{ marginTop: "10px" }}>
        <label>
          <input
            type="checkbox"
            checked={showFaqs}
            onChange={() => setShowFaqs(!showFaqs)}
          />{" "}
          Include FAQs
        </label>
      </div>

      {showFaqs && (
        <div>
          <h3>FAQs</h3>
          {faqs.map((faq, index) => (
            <div key={index}>
              <input
                type="text"
                placeholder="Enter question"
                value={faq.question}
                onChange={(e) =>
                  handleFaqChange(index, "question", e.target.value)
                }
                style={{ width: "100%", padding: "8px", marginBottom: "5px" }}
              />
              <input
                type="text"
                placeholder="Enter answer"
                value={faq.answer}
                onChange={(e) =>
                  handleFaqChange(index, "answer", e.target.value)
                }
                style={{ width: "100%", padding: "8px", marginBottom: "10px" }}
              />
            </div>
          ))}
          <button
            onClick={handleAddFaq}
            style={{ marginTop: "5px", padding: "5px 10px", cursor: "pointer" }}
          >
            Add FAQ
          </button>
        </div>
      )}

      <button
        onClick={handleSubmit}
        style={{ marginTop: "10px", padding: "8px 16px", cursor: "pointer" }}
      >
        Submit
      </button>

      <h3>Saved Blogs</h3>
      <ul>
        {blogs.map((blog) => (
          <li key={blog._id}>
            <h4>{blog.title}</h4>

            <div dangerouslySetInnerHTML={{ __html: blog.content }}></div>
            {blog.faqs && blog.faqs.length > 0 && (
              <div>
                <h4>FAQs</h4>
                {blog.faqs.map((faq, idx) => (
                  <details key={idx} style={{ marginBottom: "10px" }}>
                    <summary style={{ fontWeight: "bold", cursor: "pointer" }}>
                      {faq.question}
                    </summary>
                    <p style={{ marginLeft: "10px" }}>{faq.answer}</p>
                  </details>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogsAdmin;
